module.exports = __webpack_public_path__ + "img/ijsvissen.9ef9f570.jpeg";